
<div #BS_MODAL class="modal fade" id="NG_Modal_Content" tabindex="-1" aria-labelledby="NG_Modal_Content" aria-hidden="true">
	<div class="modal-dialog">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" >{{content.title}}</h5>
				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
			</div>
			<div class="modal-body">
				<div *ngFor="let bodyString of content.bodyStrings">
					<p>{{bodyString}}</p>
				</div>
				<div [innerHTML]="content.bodyHtml"></div>
				<ng-container #INJECTED *ngComponentOutlet="content.injectedComponent; inputs: content.injectedInputs" ></ng-container>
			</div>
			<div class="modal-footer">
				<div *ngFor="let button of content.buttons">
					<button type="button" class="btn" [ngClass]="button.className" [attr.data-bs-dismiss]="button.close ? 'modal' : null" (click)="button.callback ? button.callback() : null">{{button.text}}</button>
				</div>
			</div>
		</div>
	</div>
</div>
